export const ORDER_ALREADY_PAYED             = 'error.order.already.payed';
export const COMPLETED                       = 'COMPLETED';
export const CONFIRM_3DS_REQUIRED            = 'CONFIRM_3DS_REQUIRED';
export const CONFIRM_REDEMPTION_3DS_REQUIRED = 'CONFIRM_REDEMPTION_3DS_REQUIRED';

// Apple Pay
export const MERCHANT_EDNPOINT         = '/payment/apple/verification';
export const PAYMENT_CREATION_EDNPOINT = '/payment/creation';
export const COUNTRY_CODE              = 'RU';
export const CURRENCY_CODE             = 'RUB';
export const LABEL                     = 'S7 Airlines';
export const SUPPORTED_NETWORKS        = 'visa,masterCard';
export const MIR_NETWORK_VERSION       = 11;
export const MIR_NETWORK               = 'mir';
export const CAPABILITIES              = 'supports3DS';
export const LINE_PAYMENT_TYPE         = 'final';
export const APPLE_PAY_API_VERSION     = 2;

export const EN_LOCALE = 'en';
export const RU_LOCALE = 'ru';

export const PORTAL_COOKIE = 'portal';